// Stutta öryggissíðan á /security, á báðum málum. Ítarlega tæknilega lýsingin
// er á /security/technical, eingöngu á ensku. Allt hér endurtekur það sem
// stendur þar; breytið hvoru tveggja saman. Orðaval: sjá GLOSSARY.md.
const securitySummary = {
  header: {
    kicker: "Öryggi",
    title: "Hvernig gögnin þín eru vernduð",
    leadA:
      "Hver sá sem er beðinn um að treysta upplýsingakerfi fyrir sjúklingagögnum á rétt á að vita hvernig gögnin eru vernduð. Hér er stutta útgáfan. Ítarleg tæknileg lýsing, ætluð þeim sem yfirfara öryggismál, er á ",
    leadLink: "tæknisíðunni",
    leadB: " (eingöngu á ensku).",
  },
  readMore: "Nánar (á ensku)",
  englishOnlyNotice: "Þessi síða er eingöngu á ensku.",
  englishOnlyBackLink: "Til baka í samantektina",
  identities: {
    title: "Auðkennum er skipt út og lyklarnir geymdir sér",
    body: "Þegar gögn koma inn í kerfið er auðkennum eins og kennitölum, nöfnum og símanúmerum skipt út fyrir dulnefni. Hvert verkefni hefur sinn eigin lykil, svo dulnefni úr einu verkefni gagnast ekki í neinu öðru. Lyklarnir eru geymdir í sérstakri lyklaþjónustu, ekki í gagnagrunninum.",
  },
  access: {
    title: "Að sjá gagnasafn er ekki það sama og að geta lesið það",
    body: "Það að sjá að gagnasafn sé til og það að geta sótt það eru tvær aðskildar heimildir. Til að sækja gögn þarf að vera í verkefni gagnasafnsins og hafa annaðhvort aðgang sem gildir fyrir allt verkefnið, samþykki verkefnisstjóra eða að verkefnisstjóri hafi deilt gögnunum með viðkomandi. Ákvörðunin er tekin á einum stað og athuguð aftur í hvert sinn sem gögn fara út úr kerfinu. Deildarstjórar hafa yfirsýn yfir allt í sinni deild en geta ekki sótt rannsóknargögn.",
  },
  encrypted: {
    title: "Geymd dulkóðuð og send dulkóðuð",
    body: "Gagnaskrár og upprunaleg auðkennisgildi eru geymd dulkóðuð, hvert gagnasafn undir sínum eigin lykli. Öll samskipti við kerfið eru dulkóðuð (TLS), og aðeins sú eina tenging er aðgengileg utan frá.",
  },
  login: {
    title: "Hverjir geta skráð sig inn",
    body: "Aðgangur er eingöngu stofnaður með boði og allir aðgangar þurfa að nota tveggja þátta auðkenningu. Endurteknar misheppnaðar innskráningar eru hægðar og innskráningar frá nýjum stað eru skráðar.",
  },
  detection: {
    title: "Persónuupplýsingar í upphleðslum",
    body: "Þegar skrá er hlaðið upp leitar kerfið að persónuupplýsingum, líka auðkennum sem leynast í lausum texta, eins og kennitölu í athugasemdadálki, og sýnir það sem fannst áður en nokkuð er vistað. Þetta er hjálpartæki, ekki trygging: sá sem hleður upp tekur ákvörðunina og ætti að yfirfara skrána vandlega.",
  },
  audit: {
    title: "Allt er skráð",
    body: "Innskráningar, upphleðslur, niðurhal (hver, hvenær og hvaða dálkar), beiðnir og ákvarðanir um þær, deilingar og breytingar á heimildum eru skráðar í atburðaskrá sem ekki er hægt að breyta í gegnum kerfið. Sú skráning gerir verkefni kleift að svara siðanefnd eða eftirlitsaðila með gögnum.",
  },
  retention: {
    title: "Varðveisla og eyðing",
    body: "Gagnasafni má gefa gildistíma. Eftir hann getur enginn sótt gagnasafnið, og eftir stuttan frest er skránni og lykli hennar eytt, svo ekki er hægt að endurheimta gögnin, ekki einu sinni úr afritum. Skráningin um hverjir notuðu gagnasafnið varðveitist.",
  },
  limitations: {
    title: "Það sem kerfið ver ekki gegn",
    intro: "Við tilgreinum þær takmarkanir sem við vitum um. Þær helstu, á mannamáli:",
    anonymousStrong: "Dulnefnd gögn eru ekki nafnlaus.",
    anonymousRest:
      " Lítill hópur með sjaldgæfa greiningu getur samt verið persónugreinanlegur út frá gögnunum sjálfum. Skyldur þínar gagnvart gögnunum standa áfram.",
    operatorsStrong: "Þeir sem reka netþjónana njóta trausts.",
    operatorsRest:
      " Sá sem hefur fullan aðgang að netþjóninum og lyklaþjónustunni gæti tæknilega séð lesið gögnin. Í dag er komið í veg fyrir það með verklagi, ekki tæknilegri vörn. Þetta er mikilvægasta opna atriðið.",
    keysStrong: "Ekki er hægt að skipta út lyklum verkefna",
    keysRest: " ef einhver þeirra kemst einhvern tíma í rangar hendur.",
    auditStrong: "Atburðaskráin er geymd í gagnagrunninum.",
    auditRest:
      " Ekki er hægt að breyta henni í gegnum kerfið, en hún er ekki enn afrituð í aðskilda, óbreytanlega geymslu.",
    fullListA: "Allur listinn er undir ",
    fullListLink: "Þekktar takmarkanir",
    fullListB: " (á ensku).",
  },
  report: {
    title: "Að tilkynna vandamál",
    bodyA: "Ef þú telur þig hafa fundið öryggisvandamál skaltu skrifa okkur á ",
    bodyB:
      " eða láta deildarstjórann þinn vita. Vinsamlegast prófaðu ekki meira en þarf til að sýna fram á vandamálið, og skoðaðu hvorki né geymdu gögn annarra. Allar ábendingar eru vel þegnar, líka þær sem þú ert ekki viss um.",
  },
};

export default securitySummary;
